import { useCallback, useEffect, useState } from 'react';
import { useBFFWebChatDispatch } from './state';
import { useBFFWebChatConfig } from './state/useBFFWebChatConfig';
import { useDirectLine } from './useDirectLine';
import { useIsMounted } from './useIsMounted';
import { useWebChatStart } from './useWebChatStart';
import { useWebChatStore } from './useWebChatStore';
export const useWebChatBootstrap = (config) => {
    const [loading, setLoading] = useState(true);
    const dispatch = useBFFWebChatDispatch();
    const webChatConfig = useBFFWebChatConfig();
    const webChatStart = useWebChatStart((message) => config.isConversationTrigger(message));
    const isMounted = useIsMounted();
    const initConversation = useCallback(async (newConversation) => {
        setLoading(true);
        const webChatConfig = await config.getWebChatConfig({ newConversation });
        if (isMounted() && webChatConfig) {
            dispatch({ type: 'setConfig', config: webChatConfig });
        }
    }, [dispatch, setLoading, isMounted]);
    useEffect(() => {
        if (webChatStart.isStarted) {
            (async () => {
                await initConversation(false);
            })();
        }
    }, [webChatStart]);
    useEffect(() => {
        config.onComponentMounted();
    }, []);
    useEffect(() => {
        var _a;
        if (!loading && webChatConfig && webChatStart.isStarted) {
            (_a = config.onConversationStarted) === null || _a === void 0 ? void 0 : _a.call(config, webChatConfig, webChatStart.trigger);
        }
    }, [loading, webChatConfig, webChatStart]);
    const [store, destroyStore] = useWebChatStore(webChatConfig, {
        onDirectLineConnected: () => {
            var _a;
            setLoading(false);
            (_a = config.onDirectLineConnected) === null || _a === void 0 ? void 0 : _a.call(config, webChatConfig);
        },
        onSessionActivity: () => { var _a; return (_a = config.onSessionActivity) === null || _a === void 0 ? void 0 : _a.call(config); },
        onSessionExpired: () => {
            destroyStore === null || destroyStore === void 0 ? void 0 : destroyStore();
            dispatch({ type: 'feedbackClose' });
            initConversation(true);
        },
        middleware: config.storeMiddleware
    });
    const directLine = useDirectLine(webChatConfig);
    return {
        webChatConfig,
        loading,
        directLine,
        store
    };
};
//# sourceMappingURL=useWebChatBootstrap.js.map